"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const WarningIcon_1 = __importDefault(require("src/icons/WarningIcon"));
const TokenIcon = ({ tokenInfo, width = 24, height = 24, }) => {
    const [hasError, setHasError] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        setHasError(false);
    }, [tokenInfo]);
    return ((0, jsx_runtime_1.jsx)("div", { className: "text-xs flex items-center justify-center", style: { width, height }, children: tokenInfo && (tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.logoURI) && !hasError ? (
        // eslint-disable-next-line @next/next/no-img-element
        (0, jsx_runtime_1.jsx)("img", { onError: () => setHasError(true), src: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.logoURI, alt: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol, width: width, height: height, className: 'rounded-full overflow-hidden' })) : ((0, jsx_runtime_1.jsx)("div", { className: "relative items-center justify-center rounded-full bg-black/20", style: { width, height }, children: (0, jsx_runtime_1.jsx)(WarningIcon_1.default, { width: Math.max(width * 0.6, 16), height: Math.max(height * 0.6, 16), className: "absolute -p-1 text-warning -bottom-[2px] -right-[5px]" }) })) }));
};
exports.default = TokenIcon;
